import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Input } from "antd";
import _ from "lodash";

import { nicknameRegex, validate } from "../../../utils/validations";
import { getOnPremiseIp } from "../../../redux/actions/integrationsActions";

const TFCCreation = ({ wizardState, setWizardState, setSubmitDisabled }) => {
  const [form] = Form.useForm();
  const layout = {};
  const dispatch = useDispatch();
  const publicIps = useSelector((state) => state.integrationsReducer.publicIps);

  const [loadingIps, setLoadingIps] = useState(false);

  useEffect(() => {
    handleFetchOnpremIPS();
  }, []);

  const handleFetchOnpremIPS = async () => {
    setLoadingIps(true);
    await dispatch(getOnPremiseIp());
    setLoadingIps(false);
  };

  const checkValidation = (formValues) => {
    let formValid = true;
    const { name, apiToken } = formValues;

    if (_.isEmpty(name) || _.isEmpty(apiToken)) {
      formValid = false;
    }

    if (!_.isEmpty(name) && !validate(nicknameRegex.regex, name)) {
      formValid = false;
    }
    return setSubmitDisabled(!formValid);
  };

  const renderIps = () => {
    if (_.isEmpty(publicIps)) {
      return null;
    }
    return (
      <div className="col">
        <span>Please allow external access to the following IPs:</span>
        <div className="row" style={{ gap: "5px" }}>
          {_.map(publicIps, (item) => (
            <span className="code-flag" key={item}>
              {item}
            </span>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="TFCCreation col">
      <div className="TFCCreation__intro col">
        <span className="dark-blue bold">Procedure</span>
        <ol className="dark-blue TFCCreation__intro-list">
          <li key="1">
            Go{" "}
            <a
              target="_blank"
              href="https://www.terraform.io/docs/cloud/users-teams-organizations/users.html#api-tokens"
              rel="noreferrer"
              className="underline"
            >
              {" "}
              here
            </a>
            , to generate an API token. Copy the token.
          </li>
          <li key="2">
            Enter a <span className="purple-text med-bold">Nickname</span>, and paste the API
            token.
          </li>
          <li key="3">
            Select <span className="purple-text med-bold">Next</span>.
          </li>
        </ol>
        <span className="dark-blue">
          For Terraform Enterprise, enter the domain name of your Terraform
          Enterprise environment in the{" "}
          <span className="purple-text med-bold">Terraform Enterprise</span> box.
        </span>
      </div>
      <Form
        {...layout}
        name="tfc-wizard-form"
        form={form}
        initialValues={{
          name: wizardState.name || "TFC Integration",
          apiToken: wizardState.apiToken || "",
        }}
        className="AppWizard__content-body-form"
        onValuesChange={(
          changedValues,
          allValues // this is how you can get the form values
        ) => {
          setWizardState(Object.assign(wizardState, allValues));
          checkValidation(allValues);
        }}
      >
        <Form.Item
          label="Nickname"
          name="name"
          rules={[
            {
              required: true,
              message: "Nickname is required",
            },
            {
              pattern: nicknameRegex.regex,
              message: nicknameRegex.msg,
            },
          ]}
          style={{ marginBottom: "1.5rem", flexDirection: "column" }}
        >
          <Input placeholder="Please fill integration name" />
        </Form.Item>
        <Form.Item
          label="API token"
          name="apiToken"
          rules={[
            {
              required: true,
              message: "API token is required",
            },
          ]}
          style={{ marginBottom: "1.5rem", flexDirection: "column" }}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Terraform Enterprise"
          name="customDomain"
          style={{ marginBottom: "1.5rem", flexDirection: "column" }}
          tooltip='A valid Terraform Enterprise domain is https://your-domain.com'
          help={
            <span
              className="small-dark-blue"
              style={{
                opacity: 0.7,
                fontSize: "12px",
                transform: "translateY(10px)",
              }}
            >
              {loadingIps ? "loading.." : renderIps()}
            </span>
          }
        >
          <Input placeholder="Optional" />
        </Form.Item>
      </Form>
    </div>
  );
};

export default TFCCreation;
